import type { Language } from './i18n'

type CountNoun = 'component' | 'edge' | 'effect' | 'mechanism' | 'node' | 'pair' | 'profile' | 'stack' | 'substance'

const ruForms: Record<CountNoun, [string, string, string]> = {
  component: ['компонент', 'компонента', 'компонентов'],
  edge: ['связь', 'связи', 'связей'],
  effect: ['эффект', 'эффекта', 'эффектов'],
  mechanism: ['механизм', 'механизма', 'механизмов'],
  node: ['узел', 'узла', 'узлов'],
  pair: ['пара', 'пары', 'пар'],
  profile: ['профиль', 'профиля', 'профилей'],
  stack: ['стек', 'стека', 'стеков'],
  substance: ['вещество', 'вещества', 'веществ'],
}

const enForms: Record<CountNoun, string> = {
  component: 'component',
  edge: 'edge',
  effect: 'effect',
  mechanism: 'mechanism',
  node: 'node',
  pair: 'pair',
  profile: 'profile',
  stack: 'stack',
  substance: 'substance',
}

export function formatCount(count: number, noun: CountNoun, language: Language) {
  if (language === 'en') return `${count} ${enForms[noun]}${count === 1 ? '' : 's'}`
  const mod10 = count % 10
  const mod100 = count % 100
  const forms = ruForms[noun]
  const form = mod10 === 1 && mod100 !== 11
    ? forms[0]
    : mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)
      ? forms[1]
      : forms[2]
  return `${count} ${form}`
}
